module.exports = __webpack_public_path__ + "/images/shop/icon/filter_car_front.svg";